import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProgressReportRowDto } from './models/progress-report-row.dto';

@Injectable({ providedIn: 'root' })
export class ReportsProvider {
  constructor(private http: HttpClient) {}

  /** from and to are UTC instants (ISO 8601 with Z), to exclusive. */
  getReports(from: string, to: string): Observable<ProgressReportRowDto[]> {
    const url = '/api/production/reports';
    return this.http.get<ProgressReportRowDto[]>(url, { params: { from, to } });
  }

  /**
   * The same range as an .xlsx workbook (0106), its clock readings in timeZone (an IANA id). The
   * whole response, so the file name can be read from Content-Disposition — same origin behind
   * the dev proxy and Caddy, so the header is readable without CORS exposure.
   */
  exportReports(from: string, to: string, timeZone: string): Observable<HttpResponse<Blob>> {
    const url = '/api/production/reports/export';
    return this.http.get(url, { params: { from, to, timeZone }, responseType: 'blob', observe: 'response' });
  }
}
